module.exports = __webpack_public_path__ + "img/dcn.f3c07d96.svg";